import { yupResolver } from '@hookform/resolvers/yup';

import * as yup from 'yup';

import { LoginFormFields } from './types';

import { EMAIL_PATTERN } from '../../lib/constants';
import { EMAIL_ERROR_MESSAGE } from './constants';

const loginFormValidationSchema: yup.ObjectSchema<LoginFormFields> = yup
    .object()
    .shape({
        email: yup
            .string()
            .required()
            .matches(EMAIL_PATTERN, EMAIL_ERROR_MESSAGE),
        password: yup.string().required(),
        remember: yup.boolean().default(false).required(),
    })
    .required();

export const loginFormResolver = yupResolver(loginFormValidationSchema);
